import { render, staticRenderFns } from "./LogoutButton.vue?vue&type=template&id=e4ef148c&"
import script from "./LogoutButton.vue?vue&type=script&lang=ts&"
export * from "./LogoutButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports